import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import AddOkrReducer from './reducers/addOkr.reducers';
import * as AddOkrActions from './actions/addOkr.actions';
import AddOkrApp from './components/addOkr.component';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import EditSingleMetric from './components/okr/wizard/editSingleMetric.component';
import GoalServices from './services/goal.services';
import { reactLoader, removeReactLoader } from './utils/common';
import { CoauthorRoot } from './components/okr/wizard/coauthor';

const mapsStateToPropsAddOkr = state => ({
  addOkrData: state,
});

const mapsDispatchToPropsAddOkr = dispatch => ({
  actions: bindActionCreators(AddOkrActions, dispatch),
});

const AddOkrAppComp = connect(mapsStateToPropsAddOkr, mapsDispatchToPropsAddOkr)(AddOkrApp);

async function renderAddGoalPage(data) {
  const mountId = document.getElementById('add_goal_page');
  if (mountId) {
    const addOkrStore = createStore(AddOkrReducer, data);
    ReactDOM.render(
      <Provider store={addOkrStore}>
        <Suspense fallback="loading...">
          <I18nextProvider i18n={i18n}>
            <AddOkrAppComp />
            <CoauthorRoot />
          </I18nextProvider>
        </Suspense>,
      </Provider>,
      mountId,
    );
  }
}

const initEditSingleMetric = async function (goalId, metId, options = undefined, noGoalCheck = undefined) {
  const service = new GoalServices();
  reactLoader(true);
  const editKR = async (goalId, metId, params) => service.editKr({ goalId, metId, ...params });
  const response = await editKR(goalId, metId, { noGoalCheck });
  const { data = {}} = response;
  const responseData = data.data || {};
  removeReactLoader();
  if (!Object.keys(responseData).length) return null;
  const optionalParams = options ? options : {};

  // lazy-load edit metric css (large stylesheet)
  const editMetricCssLink = document.createElement('link');
  editMetricCssLink.rel = 'stylesheet';
  editMetricCssLink.type = 'text/css';
  editMetricCssLink.href = window.wbConfig.cssCdnUrl + '/css/okr-edit-metric.css?v=' + window.css_js_version_control;
  editMetricCssLink.onload = function () {
    if (optionalParams.onOpened) optionalParams.onOpened();
    ReactDOM.render(
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <EditSingleMetric
            goalId={goalId}
            metId={metId}
            {...optionalParams}
            {...responseData}
          />
          <CoauthorRoot />
        </I18nextProvider>
      </Suspense>,
      document.getElementById('mySidenasSingleEdit')
    );
  };

  document.getElementsByTagName('head')[0].appendChild(editMetricCssLink);
};

window.initEditSingleMetric = initEditSingleMetric;
window.renderAddGoalPage = renderAddGoalPage;
